/**
 * Picks the right Croatian noun form for a count.
 *
 * Rules (matching everyday spoken usage):
 *   - 1, 21, 31, … (but not 11) → singular nominative.
 *   - 2/3/4, 22/23/24, 32/33/34, … (but not 12/13/14) → paucal/dual form.
 *   - Everything else → genitive plural.
 *
 * Pass the three forms in the order `[one, paucal, many]`, e.g.
 * `['igra', 'igre', 'igara']` for "game" or `['sustav', 'sustava', 'sustava']`
 * for "system" (where the paucal and genitive plural happen to coincide).
 */
export function pluralizeCroatian(count: number, [one, paucal, many]: [string, string, string]): string {
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (mod10 === 1 && mod100 !== 11) {
        return one;
    }

    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
        return paucal;
    }

    return many;
}
